import { fetchLibraDietApiData } from './apiData'
import { localizePath, initRequestOptions } from '../utils/api'

const path = '/accounts'

export const accountsShow = (locale, accessToken, username) => (dispatch) => {
	const endpoint = localizePath(locale, `${path}/${username}`)
	const options = initRequestOptions({ accessToken })

	return dispatch(fetchLibraDietApiData({ endpoint, options }))
}
